import {IWixStatic} from '@wix/yoshi-flow-editor'

export const getCommonBiParams = (Wix: IWixStatic) => ({
  comp_id: Wix.Utils.getOrigCompId(),
  instance_id: Wix.Utils.getInstanceId(),
})
